// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"03b632cd","794":"c927be9d"}[chunkId] + ".chunk.css";
};